import MySearchesTable from './MySearchesTable'
export default MySearchesTable
